// extracted by mini-css-extract-plugin
module.exports = {"search_grid_container":"search-result-grid_search_grid_container__2oUXr","heading_section":"search-result-grid_heading_section__21XLg"};